import React from "react";
import { VLYT } from "@/constants/testIds/vlyt";

const ITEMS = [
  "Covenant University",
  "Hebron Community",
  "Zero-Leakage",
  "No-SIM Auth",
  "Royal Rides",
  "Cohort 01",
  "Student-Built",
  "Campus-Native",
];

export default function Marquee() {
  const track = [...ITEMS, ...ITEMS];
  return (
    <section
      className="relative border-y border-[color:var(--vlyt-border)] bg-[color:var(--vlyt-surface-1)] overflow-hidden"
      data-testid={VLYT.marquee.section}
      aria-label="Trusted context"
    >
      <div className="marquee-track py-6">
        {track.map((t, i) => (
          <div
            key={`${t}-${i}`}
            className="flex items-center gap-8 px-8 shrink-0 text-[color:var(--vlyt-muted)] font-mono uppercase text-[13px] tracking-[0.32em]"
          >
            <span className="text-lime">◆</span>
            <span>{t}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
